import { Icon, IconProps } from "../";

export const ErrorIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.77121 20.4324C1.22872 19.5024 1.22617 18.3531 1.75498 17.4376L9.37554 3.62661C9.9039 2.67166 10.9092 2.07898 12.0005 2.07898C13.0919 2.07898 14.0972 2.67166 14.6261 3.62762L22.2365 17.4207C22.7749 18.3531 22.7724 19.5024 22.2299 20.4324C21.6874 21.3624 20.6882 21.9303 19.6205 21.9208L4.38943 21.9208C3.31286 21.9303 2.31368 21.3624 1.77121 20.4324ZM11.9999 8C11.4477 8 10.9999 8.44772 10.9999 9V13.5C10.9999 14.0523 11.4477 14.5 11.9999 14.5C12.5522 14.5 12.9999 14.0523 12.9999 13.5V9C12.9999 8.44772 12.5522 8 11.9999 8ZM11.9999 16C11.3096 16 10.7499 16.5596 10.7499 17.25C10.7499 17.9404 11.3096 18.5 11.9999 18.5C12.6903 18.5 13.2499 17.9404 13.2499 17.25C13.2499 16.5596 12.6903 16 11.9999 16Z"
      />
    </Icon>
  );
};
